import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_ORIGIN = 'https://classiquemobility.com';

/**
 * Per-page title, description, and canonical.
 */
const SeoHead = ({ title, description, canonicalPath, noIndex = false }) => {
    const canonical = canonicalPath
        ? `${SITE_ORIGIN}${canonicalPath.startsWith('/') ? canonicalPath : `/${canonicalPath}`}`
        : SITE_ORIGIN;

    return (
        <Helmet>
            {title ? <title>{title}</title> : null}
            {description ? <meta name="description" content={description} /> : null}
            <link rel="canonical" href={canonical} />
            {title ? <meta property="og:title" content={title} /> : null}
            {description ? <meta property="og:description" content={description} /> : null}
            <meta property="og:url" content={canonical} />
            <meta property="og:type" content="website" />
            {noIndex ? <meta name="robots" content="noindex,follow" /> : null}
        </Helmet>
    );
};

export default SeoHead;
export { SITE_ORIGIN };
